import { FC } from 'react';
import { Dialog, DialogTitle, DialogContent, IconButton, Box } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { DiscountItemTable } from './DiscountItemTable';
import { TDiscountItemTableDialogProps } from './types';

export const DiscountItemTableDialog: FC<TDiscountItemTableDialogProps> = ({
	open,
	onClose,
	title,
	items,
	loading,
	currency,
}) => {
	return (
		<Dialog
			open={open}
			onClose={onClose}
			fullWidth
			maxWidth="xl"
			PaperProps={{
				sx: { borderRadius: '12px', minHeight: '20vh' },
			}}
		>
			<Box
				sx={{
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'space-between',
					pr: 1,
				}}
			>
				<DialogTitle sx={{ fontWeight: 'bold' }}>{title ?? 'Discount Item Table'}</DialogTitle>
				<IconButton onClick={onClose} size="small">
					<CloseIcon fontSize="small" />
				</IconButton>
			</Box>
			<DialogContent dividers sx={{ p: 0 }}>
				<DiscountItemTable items={items} loading={loading} currency={currency} />
			</DialogContent>
		</Dialog>
	);
};
